module.exports = __webpack_public_path__ + "static/img/bronze 1.b69decf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/bronze 1.png
// module id = Ppj5
// module chunks = 35